import equal from 'fast-deep-equal/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { State } from '~/Reducers';
import RefManager, { RefManagerKeys } from '~/RefManager';

interface IStateSelector {
    viewClassName: string;
    viewBackground: string;
    port: IPort;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        viewClassName: state.ReducerApp.viewClassName,
        viewBackground: state.ReducerApp.viewBackground,
        port: state.ReducerApp.port,
    };
};

export default function useArmoryBackground() {
    const { viewBackground, viewClassName, port } = useSelector<State, IStateSelector>(stateSelector, equal);

    React.useEffect(() => {
        const body = document.body;
        const backgroundElement = RefManager.getRef(RefManagerKeys.ViewBackground);

        if (viewClassName) {
            body.classList.add(viewClassName);
        } else {
            body.className = [...body.classList].filter((name) => name.includes('transparent') || (viewClassName && name === viewClassName)).join(' ');
        }

        if (backgroundElement) {
            backgroundElement.style.backgroundImage = viewBackground ? `url(${viewBackground})` : '';

            if (port?.isVisible) {
                backgroundElement.style.display = 'none';
            } else {
                backgroundElement.style.display = 'block';
            }
        }
    });
}
